// extracted by mini-css-extract-plugin
export default {"heading":"ky-z","corrected":"ly-z","redirectVerbiageContainer":"my-z","redirectVerbiageText":"ny-z"};